var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ProgrammingBugThreatFolder component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconProgrammingBugThreatFolder extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.71494 2.76573C9.56731 2.65353 9.38569 2.59529 9.20034 2.60069C9.19306 2.6009 9.18578 2.601 9.1785 2.601H3.41688C3.20168 2.601 2.9953 2.68649 2.84313 2.83866M9.71496 2.76574C9.86093 2.87669 9.96497 3.03376 10.0102 3.2113L10.4455 5.13903C10.5227 5.48099 10.8265 5.72384 11.1771 5.72384H20.5456C20.7608 5.72384 20.9672 5.80935 21.1193 5.96143C21.2715 6.11369 21.357 6.32012 21.357 6.53525V12.7809C21.357 13.1951 21.6928 13.5309 22.107 13.5309C22.5212 13.5309 22.857 13.1951 22.857 12.7809V6.53525C22.857 5.92214 22.6134 5.33429 22.1801 4.90089C21.7466 4.46731 21.1585 4.22384 20.5456 4.22384H11.7766L11.4715 2.87249L11.4681 2.85801C11.3415 2.34514 11.0431 1.89112 10.6226 1.57151L10.6226 1.57149C10.2052 1.25429 9.69248 1.08846 9.16864 1.101H3.41688C2.80385 1.101 2.21594 1.34453 1.78247 1.778L1.78246 1.778C1.34899 2.21148 1.10547 2.79939 1.10547 3.41242V18.2459C1.10547 18.8588 1.34896 19.4468 1.78252 19.8803L2.31101 19.3517L1.78252 19.8803C2.21592 20.3136 2.80378 20.5573 3.41688 20.5573H7.32042C7.73463 20.5573 8.07042 20.2215 8.07042 19.8073C8.07042 19.3931 7.73463 19.0573 7.32042 19.0573H3.41688C3.20175 19.0573 2.99532 18.9718 2.84308 18.8196C2.69099 18.6675 2.60547 18.4611 2.60547 18.2459V3.41242C2.60547 3.19722 2.69096 2.99083 2.84312 2.83866"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.1537 12.5162C16.1686 12.5065 16.1884 12.5 16.2104 12.5ZM15.3338 11.2601C15.5949 11.0897 15.9 11 16.2104 11C16.5207 11 16.826 11.0897 17.0871 11.2602C17.3346 11.4217 17.5328 11.6497 17.6565 11.9197L22.1329 19.8952C22.2704 20.1421 22.3434 20.4201 22.3434 20.7039C22.3434 20.9847 22.272 21.2598 22.1373 21.5048C22.0004 21.7614 21.7956 21.9741 21.5472 22.1219C21.2964 22.2709 21.0094 22.3491 20.7186 22.3491H11.6248C11.334 22.3491 11.0475 22.2712 10.7967 22.1222C10.5485 21.9745 10.343 21.7616 10.2061 21.5048C10.0713 21.2597 10 20.9845 10 20.7039C10 20.4203 10.0728 20.1422 10.2105 19.8951L10.2143 19.8882L14.7657 11.9167C14.8895 11.648 15.0872 11.4211 15.3338 11.2601ZM16.2104 12.5C16.2325 12.5 16.2523 12.5065 16.2669 12.5161ZM16.2669 12.5161C16.2816 12.5257 16.2897 12.537 16.2934 12.5459ZM16.1537 12.5162C16.1391 12.5258 16.1311 12.5371 16.1273 12.5461C16.1156 12.574 16.1022 12.6012 16.0871 12.6275L11.5198 20.6271C11.5063 20.652 11.5 20.6783 11.5 20.7039C11.5 20.7302 11.5067 20.7573 11.5209 20.7828L11.5296 20.7988C11.5355 20.8101 11.5462 20.8228 11.5634 20.833C11.5805 20.8431 11.6014 20.8491 11.6248 20.8491H20.7186C20.7419 20.8491 20.7634 20.8428 20.7806 20.8326C20.7976 20.8225 20.8078 20.8103 20.8138 20.7988L20.8224 20.7829C20.8367 20.7572 20.8434 20.7301 20.8434 20.7039C20.8434 20.6779 20.8368 20.6511 20.8227 20.6255L16.331 12.6227C16.317 12.5978 16.3045 12.5722 16.2934 12.5459"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.1777 15.071C16.5919 15.071 16.9277 15.4068 16.9277 15.821V17.0741C16.9277 17.4883 16.5919 17.8241 16.1777 17.8241C15.7635 17.8241 15.4277 17.4883 15.4277 17.0741V15.821C15.4277 15.4068 15.7635 15.071 16.1777 15.071ZM16.1777 18.458C16.5919 18.458 16.9277 18.7938 16.9277 19.208V19.2388C16.9277 19.653 16.5919 19.9888 16.1777 19.9888C15.7635 19.9888 15.4277 19.653 15.4277 19.2388V19.208C15.4277 18.7938 15.7635 18.458 16.1777 18.458Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconProgrammingBugThreatFolder.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconProgrammingBugThreatFolder.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconProgrammingBugThreatFolder.prototype, "size", void 0);
if (customElements.get('cat-icon-programming-bug-threat-folder') === undefined) {
    customElements.define('cat-icon-programming-bug-threat-folder', BlocksIconProgrammingBugThreatFolder);
}
